/* Hello Disc landing page: hero buy box (sections/lp-hero.liquid) */
(function () {
  function init(root) {
    if (!root || root.dataset.lpReady) return;
    root.dataset.lpReady = '1';
    var cfg = JSON.parse(root.querySelector('[data-lp-config]').textContent);
    var kits = {};
    cfg.kits.forEach(function (k) { kits[String(k.key)] = k; });
 
    var fmt;
    try { fmt = new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency, currencyDisplay: 'narrowSymbol' }); }
    catch (e) { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency }); }
    function money(c) { return fmt.format(c / 100); }
    function norm(x) { return String(x || '').toLowerCase().replace(/colou?r/g, 'color'); }
    function isColour(n) { return norm(n).indexOf('color') > -1; }
    function isPlug(n) { var x = norm(n); return x.indexOf('plug') > -1 || x.indexOf('region') > -1; }
 
    // Plug type from the shopper's country
    var plugValues = [];
    cfg.kits.forEach(function (k) {
      k.options.forEach(function (n, i) {
        if (!isPlug(n)) return;
        k.variants.forEach(function (v) { if (plugValues.indexOf(v.o[i]) === -1) plugValues.push(v.o[i]); });
      });
    });
    var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE NO CH IS'.split(' ');
    function plugFor(cc) {
      var want = /^(NZ|AU)$/.test(cc) ? 'australia' : cc === 'GB' ? 'kingdom' : /^(US|CA|MX)$/.test(cc) ? 'states' : EU.indexOf(cc) > -1 ? 'europe' : '';
      var hit = plugValues.filter(function (p) { return want && p.toLowerCase().indexOf(want) > -1; })[0];
      return hit || plugValues[0] || null;
    }
 
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-lp-swatch]'));
    var kitBtns = Array.prototype.slice.call(root.querySelectorAll('[data-lp-kit]'));
    var pressedSwatch = swatches.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
    var state = {
      kit: kits[cfg.defaultKit] ? String(cfg.defaultKit) : String(cfg.kits[0] && cfg.kits[0].key),
      colour: pressedSwatch ? pressedSwatch.dataset.lpSwatch : null,
      plug: plugFor(cfg.country)
    };
 
    function variantFor(k, colour) {
      if (!k) return null;
      colour = colour === undefined ? state.colour : colour;
      var match = function (v) {
        return v.o.every(function (val, i) {
          var n = k.options[i];
          if (isColour(n) && colour && k.variants.some(function (x) { return x.o[i] === colour; })) return val === colour;
          if (isPlug(n) && state.plug && k.variants.some(function (x) { return x.o[i] === state.plug; })) return val === state.plug;
          return true;
        });
      };
      var list = k.variants.filter(match);
      return list.filter(function (v) { return v.a; })[0] || list[0] || null;
    }
 
    // Plug select
    var plugWrap = root.querySelector('[data-lp-plug-wrap]');
    var plugSel = root.querySelector('[data-lp-plug]');
    if (plugSel) {
      plugValues.forEach(function (p) {
        var o = document.createElement('option'); o.value = p; o.textContent = p;
        if (p === state.plug) o.selected = true;
        plugSel.appendChild(o);
      });
      plugSel.addEventListener('change', function () { state.plug = plugSel.value; render(); });
    }
 
    var priceEl = root.querySelector('[data-lp-price]');
    var compareEl = root.querySelector('[data-lp-compare]');
    var saveEl = root.querySelector('[data-lp-save]');
    var colourName = root.querySelector('[data-lp-colour-name]');
    var addBtn = root.querySelector('[data-lp-add]');
    var addLabel = root.querySelector('[data-lp-add-label]');
    var errEl = root.querySelector('[data-lp-error]');
    var sticky = root.querySelector('[data-lp-sticky]');
    var stickyName = root.querySelector('[data-lp-sticky-name]');
    var stickyPrice = root.querySelector('[data-lp-sticky-price]');
    var stickyAdd = root.querySelector('[data-lp-sticky-add]');
 
    function render() {
      var k = kits[state.kit], v = variantFor(k);
      kitBtns.forEach(function (b) {
        var kk = kits[b.dataset.lpKit], kv = variantFor(kk);
        b.setAttribute('aria-pressed', String(b.dataset.lpKit === state.kit));
        if (!kv) return;
        var p = b.querySelector('[data-lp-kit-price]'), c = b.querySelector('[data-lp-kit-compare]');
        if (p) p.textContent = money(kv.p);
        if (c) { c.textContent = money(kv.c); c.hidden = !(kv.c > kv.p); }
      });
      swatches.forEach(function (b) {
        var val = b.dataset.lpSwatch, sv = variantFor(k, val);
        b.setAttribute('aria-pressed', String(val === state.colour));
        var colourExists = k && k.options.some(function (n, i) { return isColour(n) && k.variants.some(function (x) { return x.o[i] === val; }); });
        b.disabled = !!(colourExists && sv && !sv.a);
      });
      if (colourName && state.colour) colourName.textContent = state.colour;
      var needsPlug = k && k.options.some(isPlug);
      if (plugWrap) plugWrap.hidden = !needsPlug;
      var ok = !!(v && v.a);
      if (v) {
        priceEl.textContent = money(v.p);
        var deal = v.c > v.p;
        compareEl.hidden = !deal; compareEl.textContent = deal ? money(v.c) : '';
        if (deal && cfg.saveFormat) {
          saveEl.hidden = false;
          saveEl.textContent = cfg.saveFormat.replace('[amount]', money(v.c - v.p)).replace('[percent]', Math.round((v.c - v.p) * 100 / v.c));
        } else saveEl.hidden = true;
      }
      addLabel.textContent = ok ? cfg.buttonLabel + ' — ' + money(v.p) : (cfg.soldOut || 'Sold out');
      addBtn.setAttribute('aria-disabled', String(!ok));
      if (stickyName) {
        var btn = kitBtns.filter(function (b) { return b.dataset.lpKit === state.kit; })[0];
        var nm = btn ? btn.querySelector('.lp-kit__name').firstChild.textContent.trim() : '';
        stickyName.textContent = nm + (state.colour ? ' · ' + state.colour : '');
        stickyPrice.textContent = v ? money(v.p) : '';
        if (stickyAdd) stickyAdd.setAttribute('aria-disabled', String(!ok));
      }
    }
 
    kitBtns.forEach(function (b) { b.addEventListener('click', function () { state.kit = b.dataset.lpKit; render(); }); });
    swatches.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; state.colour = b.dataset.lpSwatch; render(); }); });
 
    function refreshCartUi(cart) {
      try {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.dataset.count = cart.item_count;
          var sp = el.querySelector('span[aria-hidden]'); if (sp) sp.textContent = cart.item_count;
        });
      } catch (e) {}
      var R = window.Rebuy, opened = false;
      try {
        if (R && R.Cart && typeof R.Cart.fetchCart === 'function') R.Cart.fetchCart();
        if (R && R.SmartCart && typeof R.SmartCart.show === 'function') { R.SmartCart.show(); opened = true; }
      } catch (e) {}
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lp-hero', cartData: cart }); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('lp:added', { detail: { cart: cart } }));
      if (!opened) window.location = (window.routes && window.routes.cart_url) || '/cart';
    }
 
    var busy = false;
    function add(btn) {
      var v = variantFor(kits[state.kit]);
      if (!v || !v.a || busy) return;
      busy = true;
      btn.setAttribute('aria-disabled', 'true');
      errEl.hidden = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || 'Could not add to cart');
          return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(refreshCartUi)
        .catch(function (e) { errEl.textContent = e.message; errEl.hidden = false; })
        .finally(function () { busy = false; render(); });
    }
    addBtn.addEventListener('click', function () { add(addBtn); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { add(stickyAdd); });
 
    // Sticky bar: show once the main button has scrolled out of view
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', off);
        sticky.setAttribute('aria-hidden', String(!off));
        if (stickyAdd) stickyAdd.tabIndex = off ? 0 : -1;
      });
      io.observe(addBtn);
    }
 
    // ---- Discounts from the AdsGun app ----
    // AdsGun shows its discounts on the theme's normal price elements but doesn't know about this
    // buy box, so ask it for each kit's discounted price and show that with the full price crossed out
    // (same approach as the Bundle Options section on the product page).
    function applyAppDiscounts(AG) {
      var jobs = cfg.kits.map(function (k) {
        if (!k.handle) return null;
        return AG.getProductData('/products/' + k.handle).then(function (prod) {
          if (!prod || !prod.variants) return null;
          return Promise.all(k.variants.map(function (v) {
            var pv = prod.variants.filter(function (x) { return x.id === v.id; })[0];
            if (!pv) return null;
            return AG.computeItemDiscount(prod, pv, 1).then(function (d) {
              var base = v.base || v.p;
              var fp = d && Math.round(Number(d.final_price));
              if (fp && fp < base && fp > base * 0.2) {
                v.base = base;
                if (!(v.c > base)) v.c = base;
                v.p = fp;
              }
            });
          }));
        }).catch(function () { return null; });
      });
      Promise.all(jobs).then(render);
    }
    var agTries = 0;
    (function waitForApp() {
      var AG = window.AdsGun;
      if (AG && typeof AG.getProductData === 'function' && typeof AG.computeItemDiscount === 'function') { applyAppDiscounts(AG); return; }
      if (++agTries < 40) setTimeout(waitForApp, 250);
    })();
 
    render();
  }
  function boot() { document.querySelectorAll('[data-lp-hero]').forEach(init); }
  // Any "#lp-buy" link scrolls smoothly to the buy box
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#lp-buy"]');
    var box = a && document.getElementById('lp-buy');
    if (!box) return;
    e.preventDefault();
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();